/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rowtargetagehint3Inputs */

const en_rowtargetagehint3 = /** @type {(inputs: Rowtargetagehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just a hint, nobody is turned away.`)
};

const de_rowtargetagehint3 = /** @type {(inputs: Rowtargetagehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur ein Hinweis, niemand wird ausgeschlossen.`)
};

/**
* | output |
* | --- |
* | "Just a hint, nobody is turned away." |
*
* @param {Rowtargetagehint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const rowtargetagehint3 = /** @type {((inputs?: Rowtargetagehint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rowtargetagehint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rowtargetagehint3(inputs)
	return de_rowtargetagehint3(inputs)
});
export { rowtargetagehint3 as "rowTargetAgeHint" }